<template>
    <el-container class="train">
        <el-header style="height: 30px">
            <van-nav-bar title="新增门店培训" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-form ref="form" :model="intebotrain" size="mini" label-width="80px">
                <el-form-item label="单号" prop="sysbillid">
                    <span>{{intebotrain.sysbillid}}</span>
                </el-form-item>
                <el-form-item label="客户门店" prop="khs">
                    <el-cascader size="mini" v-model="khs" ref="khs" style="width: 100%"
                                 :options="inteboStoreSturct" class="cascader" filterable :props="{multiple: true,checkStrictly: true}" clearable></el-cascader>
                </el-form-item>
                <el-form-item label="培训类型" prop="type">
                    <el-radio-group v-model="intebotrain.type">
                        <el-radio :label="1">总部</el-radio>
                        <el-radio :label="2">下店</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="培训内容" prop="content">
                    <el-select v-model="intebotrain.content"  style="width: 100%" size="mini">
                        <el-option label="基本操作" value="基本操作" key="基本操作"></el-option>
                        <el-option label="专业培训" value="专业培训" key="专业培训"></el-option>
                        <el-option label="Sculpture筋膜培训" value="Sculpture筋膜培训" key="Sculpture筋膜培训"></el-option>
                        <el-option label="私密培训" value="私密培训" key="私密培训"></el-option>
                        <el-option label="头皮培训" value="头皮培训" key="头皮培训"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="培训原因" prop="reason">
                    <el-select v-model="intebotrain.reason"  style="width: 100%" size="mini">
                        <el-option label="购机新店培训" value="购机新店培训" key="购机新店培训"></el-option>
                        <el-option label="赠送培训" value="赠送培训" key="赠送培训"></el-option>
                        <el-option label="购买产品培训" value="购买产品培训" key="购买产品培训"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期" prop="fromdate">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" v-model="intebotrain.fromdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="todate">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" v-model="intebotrain.todate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="培训老师" prop="header">
                    <el-select v-model="header"  style="width: 100%" size="mini" filterable default-first-option clearable multiple>
                        <el-option :label="item.staffname" :value="item.staffid" :key="key" v-for="(item,key) in inteboStaffs"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作老师" prop="header">
                    <el-select v-model="operation"  style="width: 100%" size="mini" filterable default-first-option clearable multiple>
                        <el-option :label="item.staffname" :value="item.staffid" :key="key" v-for="(item,key) in inteboStaffs"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="培训次数" v-if="intebotrain.type==2">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="intebotrain.number">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="intebotrain.remarks"></el-input>
                </el-form-item>
            </el-form>
        </el-main>
        <el-footer>
            <el-button type="primary" :loading="loading" @click="saveInteboTrain" style="width: 100%">保存</el-button>
        </el-footer>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            loading:false,
            inteboStaffs:[],
            khs:[],
            operation:[],
            header:[],
            inteboStoreSturct:[],
            intebotrain:{
                sysbillid:"",
                type:0,
                content:"",
                fromdate:"",
                todate:"",
                reason:"",
                createdate:"",
                createtor:"",
                createtorname:"",
                number:0,
                remarks:"",
            },
        }
    },
    created() {
        let type=this.$route.query.type;
        let sysbillid=this.$route.query.sysbillid;
        if(type=="update"){
            this.getInteboTrainById(sysbillid);
        }
        else{
            this.getSysBillId();
        }
        this.getInteboStoreSturct();
        this.getInteboStaffTrain();

    },
    methods:{
        getInteboTrainById(sysbillid){
            this.$post("intebosale/getInteboTrainById",{sysbillid:sysbillid}).then(res=>{
                if(res.sucess) {
                    let obj = res.object;
                    let train = obj.inteboTrain;
                    let store = obj.inteboTrainStores;
                    let teacher = obj.inteboTrainTeachers;
                    this.intebotrain = train;
                    if (store != null && store.length > 0) {
                        let storeVal = [];
                        for (let val of store) {
                            let arry = [];
                            if (val.storeid) {
                                arry.push(val.parentid);
                                arry.push(val.storeid);
                                //storeVal.push(arry);
                            } else {
                                arry.push(val.parentid);
                            }
                            storeVal.push(arry);
                        }
                        this.$nextTick(function () {
                            this.khs = storeVal;
                        });
                    }
                    if (teacher != null && teacher.length > 0) {
                        for (let val of teacher) {
                            if (val.type == 1) {
                                this.header.push(val.staffid);
                            } else if (val.type == 2) {
                                this.operation.push(val.staffid);
                            }
                        }
                    }
                }
            });
        },
        saveInteboTrain(){
            if(this.khs==null || this.khs.length<1){
                this.$message({message: "请选择培训的门店或者品牌", type: 'error'});
                return;
            }
            if(this.intebotrain.type<1){
                this.$message({message: "请选择培训类型", type: 'error'});
                return;
            }
            if(!this.intebotrain.content){
                this.$message({message: "请选择培训内容", type: 'error'});
                return;
            }
            if(!this.intebotrain.fromdate){
                this.$message({message: "请选择开始日期", type: 'error'});
                return;
            }
            if(!this.intebotrain.todate){
                this.$message({message: "请选择结束日期", type: 'error'});
                return;
            }
            /*if(this.header.length<1){
                this.$message({message: "请选择培训老师", type: 'error'});
                return;
            }*/
            let inteboTrainTeachers=[];
            for(let val of this.header){
                let obj={};
                obj.sysbillid=this.intebotrain.sysbillid;
                obj.staffid=val;
                obj.type=1;
                inteboTrainTeachers.push(obj);
            }

            for(let val of this.operation) {
                let obj = {};
                obj.sysbillid = this.intebotrain.sysbillid;
                obj.staffid = val;
                obj.type = 2;
                inteboTrainTeachers.push(obj);
            }

            let inteboTrainStores=[];
            for(let val of this.khs){
                let obj={};
                obj.sysbillid=this.intebotrain.sysbillid;
                if(val[1]){
                    obj.parentid=val[0];
                    obj.storeid=val[1];
                }
                else{
                    obj.parentid=val[0];
                }
                inteboTrainStores.push(obj);
            }
            let inteboTrainVo=new Object();
            this.intebotrain.createtor=localStorage.getItem("staffid");
            this.intebotrain.createtorname=localStorage.getItem("staffname");
            inteboTrainVo.inteboTrain=this.intebotrain;
            inteboTrainVo.inteboTrainTeachers=inteboTrainTeachers;
            inteboTrainVo.inteboTrainStores=inteboTrainStores;
            this.$postw("intebosale/saveInteboTrain",inteboTrainVo).then(res=>{
                if(res.sucess){
                    this.$router.push({path:'/intebotrain'});
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.intebotrain.sysbillid=res.object;
                }
            });
        },
        getInteboStaffTrain() {
            this.$post("inteboStaff/getInteboStaffTrain").then(res => {
                if (res.sucess) {
                    this.inteboStaffs = res.object;
                }
            });
        },
        getInteboStoreSturct(){
            this.$post("inteboScheduling/getInteboStoreSturct").then(res=>{
                if(res.sucess) {
                    this.inteboStoreSturct = res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.train .el-input-number .el-input__inner {
    text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/page/intebo/intebotab/addintebotrain.vue